export default "__VITE_ASSET__e6cda927__"